/** Builds the module-federation manifest URL for a remote dashboard widget plugin. */
export function buildRemoteManifestUrl(
  pluginUrl: string,
  specificWidgetType: string
): string {
  return `${window.location.origin}/api/${pluginUrl}/microfrontends/${specificWidgetType}/mf-manifest.json`;
}
